declare global {
  interface Window {
    adapter?: unknown;
  }
}

export const sdkVersion = '__package_version__';

export const isBrowser = typeof window !== 'undefined' && typeof document === 'object';
export const isNodeJS: boolean =
  typeof process === 'object' && typeof process.versions === 'object' && Boolean(process.versions.node);
export const isReactNative = false;
export const isExpo = false;

export const adapter = isBrowser ? window.adapter : undefined;
export const navigator = isBrowser ? window.navigator : undefined;
export const mediaDevices = isBrowser && navigator ? navigator.mediaDevices : undefined;
export const MediaStream = isBrowser ? window.MediaStream : undefined;
export const MediaStreamTrack = isBrowser ? window.MediaStreamTrack : undefined;
export const RTCIceCandidate = isBrowser ? window.RTCIceCandidate : undefined;
export const RTCPeerConnection = isBrowser ? window.RTCPeerConnection : undefined;
export const RTCRtpReceiver = isBrowser ? window.RTCRtpReceiver : undefined;
export const RTCRtpSender = isBrowser ? window.RTCRtpSender : undefined;
export const RTCSessionDescription = isBrowser ? window.RTCSessionDescription : undefined;
export const isWebRTCAvailable: boolean = isBrowser ? Boolean(mediaDevices && RTCPeerConnection) : false;

if (isWebRTCAvailable && !adapter) {
  console.warn(
    'Install WebRTC adapter if you want to use ConnectyCube.videochatconference. More info https://github.com/webrtc/adapter'
  );
}
